/**
 * The Cooked Sushi — homepage scroll reveals & staged animations
 */
(function () {
  if (!document.body.classList.contains('template-index')) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  if (reducedMotion.matches) {
    document.documentElement.classList.add('nihooya-motion-reduced');
    return;
  }

  const observed = new WeakSet();

  const groups = [
    { selector: '.nihooya-trust-strip__prologue', type: 'fade-up' },
    { selector: '.nihooya-trust-strip__beacon', type: 'fade-up', stagger: 120 },
    { selector: '.nihooya-menu-categories .nihooya-section-header', type: 'header-reveal' },
    { selector: '.nihooya-menu-categories__item', type: 'fade-up', stagger: 100 },
    { selector: '.nihooya-menu-categories__footer', type: 'fade-up', delay: 320 },
    { selector: '.nihooya-brand-story__media', type: 'slide-in' },
    { selector: '.nihooya-brand-story__content .nihooya-section-header', type: 'header-reveal', delay: 120 },
    { selector: '.nihooya-brand-story__button', type: 'fade-up', delay: 380 },
    { selector: '.template-index .collection .collection__title', type: 'fade-up' },
    { selector: '.template-index .collection .collection__description', type: 'fade-up', delay: 140 },
    { selector: '.template-index .collection .product-grid .grid__item', type: 'fade-up', stagger: 80 },
    { selector: '.template-index .collection .collection__view-all', type: 'fade-up', delay: 360 },
    { selector: '.nihooya-how-to-order .nihooya-section-header', type: 'header-reveal' },
    { selector: '.nihooya-how-to-order__step', type: 'fade-up', stagger: 120 },
    { selector: '.nihooya-testimonials .nihooya-section-header', type: 'header-reveal' },
    { selector: '.nihooya-testimonials__item', type: 'testimonial', stagger: 100 },
    { selector: '.nihooya-gallery .nihooya-section-header', type: 'header-reveal' },
    { selector: '.nihooya-gallery__item', type: 'scale-in', stagger: 100 },
    { selector: '.nihooya-gallery__footer', type: 'fade-up', delay: 400 },
    { selector: '.nihooya-newsletter__copy', type: 'header-reveal' },
    { selector: '.nihooya-newsletter__form', type: 'fade-up', delay: 220 },
  ];

  const specialTargets = [
    { selector: '.nihooya-how-to-order__steps', visibleClass: 'is-line-visible' },
    { selector: '.nihooya-order-cta', visibleClass: 'is-visible' },
    { selector: '.nihooya-trust-strip__prologue-line', visibleClass: 'is-drawn' },
    { selector: '.nihooya-brand-story__accent', visibleClass: 'is-drawn' },
  ];

  function applyAnimation(el, config, index) {
    el.classList.add('nihooya-anim', `nihooya-anim--${config.type}`);

    if (config.stagger && index > 0) {
      el.style.setProperty('--nihooya-anim-delay', `${index * config.stagger}ms`);
    } else if (config.delay) {
      el.style.setProperty('--nihooya-anim-delay', `${config.delay}ms`);
    }

    if (config.type === 'slide-in') {
      const layout = el.closest('.nihooya-brand-story__layout');
      const fromRight = layout && layout.classList.contains('nihooya-brand-story__layout--reverse');
      el.classList.add(fromRight ? 'nihooya-anim--from-right' : 'nihooya-anim--from-left');
    }
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        const el = entry.target;
        const visibleClass = el.dataset.nihooyaVisibleClass || 'is-visible';
        el.classList.add(visibleClass);
        observer.unobserve(el);
      });
    },
    {
      root: null,
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.12,
    }
  );

  function revealIfInView(el) {
    const rect = el.getBoundingClientRect();
    const inView = rect.top < window.innerHeight * 0.94 && rect.bottom > window.innerHeight * 0.04;
    if (!inView) return false;

    const visibleClass = el.dataset.nihooyaVisibleClass || 'is-visible';
    el.classList.add(visibleClass);
    observer.unobserve(el);
    return true;
  }

  function observe(el, visibleClass) {
    if (observed.has(el)) return;
    observed.add(el);
    if (visibleClass && visibleClass !== 'is-visible') {
      el.dataset.nihooyaVisibleClass = visibleClass;
    }
    if (revealIfInView(el)) return;
    observer.observe(el);
  }

  function setup() {
    groups.forEach((group) => {
      document.querySelectorAll(group.selector).forEach((el, index) => {
        applyAnimation(el, group, index);
        observe(el);
      });
    });

    specialTargets.forEach(({ selector, visibleClass }) => {
      document.querySelectorAll(selector).forEach((el) => {
        observe(el, visibleClass);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

  document.addEventListener('shopify:section:load', setup);

  reducedMotion.addEventListener('change', (event) => {
    if (event.matches) {
      document.documentElement.classList.add('nihooya-motion-reduced');
      observer.disconnect();
    }
  });
})();